import * as account from '@/modules/account/services'
import updates from '@/modules/whats-new/data/updates.json'

export function getUpdates() {
  return updates.sort((a, b) => new Date(b.date) - new Date(a.date)) ?? []
}

export function getSeenUpdateIds() {
  return account.getLocalStorage('whats-new', 'seenUpdateIds') ?? []
}

export function markUpdatesSeen(updateIds) {
  const seenUpdateIds = getSeenUpdateIds()
  const newSeenUpdatesIds = Array.from(
    new Set([...seenUpdateIds, ...updateIds])
  )
  account.setLocalStorage('whats-new', 'seenUpdateIds', newSeenUpdatesIds)
}

export function getUpdatesToShow(count = 3) {
  const updates = getUpdates().reverse()
  const seenUpdateIds = getSeenUpdateIds()
  const unseenUpdates = updates.filter(
    update => !seenUpdateIds.includes(update.id)
  )
  return unseenUpdates.slice(0, count)
}
